<template>
	<!--<div>
		<v-card-text class="py-0">-->
			<v-container fluid class="pt-0">
				<v-row style="margin-top: 10px;" class="mx-0">
					<!--<v-col cols="12" class="px-0">
						<h2 class="black--text">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.title') }}
						</h2>
					</v-col>-->
					<v-col cols="12" class="pa-0">
						<span style="font-size: 16px;">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.subtitle') }}
						</span>
					</v-col>
					<v-col cols="6" class="px-0">
						<span style="font-size: 20px;" class="black--text">{{ currentPlan }}</span>
					</v-col>
					<v-col cols="12" class="pa-0 pt-2">
						<span style="font-size: 14px;" class="black--text font-weight-bold">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.description') }}
						</span>
					</v-col>
					<v-col cols="12" class="px-0 my-2">						
						<LicenseItems 
							:company="company" 
							:licensingInfo="licensingInfo" 
							:licenseType="licenseType" 
							:licensePlan="licensePlan"
							:planEmployees="planEmployees"
							:planStorage="planStorage"
							:planSignatures="planSignatures"
							:readOnly="false" 
							:upgrade="upgrade"
							@employees-changed="$emit('employees-changed', $event)" 
							@storage-changed="$emit('storage-changed', $event)" 
							@signatures-changed="$emit('signatures-changed', $event)" />
					</v-col>
				</v-row>
			</v-container>			
		<!--</v-card-text>	
		<v-divider></v-divider>
		<v-card-actions>
			<v-btn color="#185EA9" text @click="$emit('open-rates')" style="font-size: 0.9em; font-weight: 400;">
				<v-icon small color="#185EA9" class="mr-2">open_in_new</v-icon>
				<span class="text-decoration-underline">{{ $t('wkt.admin.license.upgrade-account-window.step-1.more_info').toUpperCase() }}</span>
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="#185EA9" text @click="$emit('step-changed', 2)" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.next').toUpperCase() }}</v-btn>
			<v-btn text @click="$emit('close-dialog')" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
		</v-card-actions>
	</div>-->
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import PurchaseUtils from './PurchaseUtils.js';
import LicenseItems from './LicenseItems';

  export default {
    name: 'UpgradePlanStep2',
    mixins: [BaseModule, PurchaseUtils],
	props: ['company','licensingInfo','licenseType','licensePlan','planEmployees','planStorage','planSignatures','upgrade'],
	//props: ['company','licensingInfo','licenseType','licensePlan'],//,'numEmployees','numStorage','numSignatures'],
	watch: {
		/*company: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.planEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);
				this.planStorage = Math.floor(this.company.currentStorageLimit / 1024);

				this.minEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);
			}
		},
		licenseType: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				SKULicense license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, 0, selectedPlan, License.LICENSE_CLASS_BASE);

		int storage = planStorage.getValue();

		if (license != null && license.getQuantity().intValue() > storage) {
			storage = license.getQuantity().intValue();
		}

		planStorage.setValue(storage);

		// Valor mínimo
		storage = myCompany.getCurrentStorageLimit().intValue();

		if (license != null && license.getQuantity().intValue() > storage) {
			storage = license.getQuantity().intValue();
		}

		minStorage = storage / 1024;

		// Firmas
		const item = this.findStockSKU(licensingInfo, Stock.SMS_SIGNATURE, 0, selectedPlan, License.LICENSE_CLASS_BASE);

		int signatures = planDocuments.getValue();

		if (item != null && item.getQuantity().intValue() > signatures) {
			signatures = item.getQuantity().intValue();
		}

		planDocuments.setValue(signatures);
		summaryDocsLabel.setText(DOC_SIGNATURES_STRING + ": " + planDocuments.getValue()); // Firmas de documentos

		// Valor mínimo
		minDocuments = item.getQuantity().intValue();
				this.planEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);
				this.planStorage = Math.floor(this.company.currentStorageLimit / 1024);
				
				this.minEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);
			}
		},
		numEmployees: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				//this.selectedEmployees = newValue;
			}
		},		
		numStorage: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				//this.selectedStorage = newValue;
			}
		},
		numSignatures: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				//this.selectedSignatures = newValue;
			}
		}*/
	},
	components: {
		LicenseItems
	},
    data () {
		return {
			//planEmployees: 0,
			//plaStorage: 0,
			//planSignatures: 0,
			//minEmployees: 0,
			//minStorage: 0,
			//minSignatures: 0,

			//selectedEmployees: 0,
			//selectedStorage: 0, 
			//selectedSignatures: 0,
		}
    },
	mounted() {
		console.log(`*** UpgradePlanStep2.upgrade: ${this.upgrade}`);
		/*this.planEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);
		this.planStorage = Math.floor(this.company.currentStorageLimit / 1024);

		// Valor mínimo
		this.minEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);

		const license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_BASE);

		let storage = this.planStorage;

		if (license && license.quantity > storage) {
			storage = license.quantity;
		}

		this.planStorage = storage;

		// Valor mínimo
		storage = this.company.currentStorageLimit;

		if (license && license.quantity > storage) {
			storage = license.quantity;
		}

		this.minStorage = storage / 1024;

		// Firmas
		const item = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_BASE);

		let signatures = this.planSignatures;

		if (item && item.quantity > signatures) {
			signatures = item.quantity;
		}

		this.planSignatures = signatures;
		
		// Valor mínimo
		this.minSignatures = item.quantity;*/

		//this.selectedEmployees = this.numEmployees;
		//this.selectedStorage = this.numStorage;
		//this.selectedSignatures = this.numSignatures;
	},
	computed: {
		currentPlan() {
			if (!this.company) {
				return '???';
			}

			let text = '';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE: 
					text = this.$t('wkt.admin.license.type-free-description');
					break;
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.type-business-description');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.type-corporate-description');
					break;
			}

			text += ' - ';

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_FREE: 
					text += this.$t('wkt.admin.license.plan-free-description');
					break;
				case this.constants.LICENSE_PLAN_MONTHLY:
					text += this.$t('wkt.admin.license.plan-monthly-description');
					break;
				case this.constants.LICENSE_PLAN_ANNUAL: 
					text += this.$t('wkt.admin.license.plan-annual-description');
					break;
			}

			return text;
		},
	},
    methods: {
		/*updateEmployees(num) {
			this.selectedEmployees = num;
			this.$emit('additional-employees-changed', num);
		},
		updateStorage(num) {
			this.selectedStorage = num; 
			this.$emit('additional-storage-changed', num);
		},
		updateSignatures(num) {
			this.selectedSignatures = num; 
			this.$emit('additional-signatures-changed', num);
		},*/
    },
}
</script>